import { NgClass } from "@angular/common";
import {
  Component,
  computed,
  EventEmitter,
  inject,
  input,
  Output,
  signal,
} from "@angular/core";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import {
  BRAND_CAMPAIGN_STATUS_FILTERS,
  BrandCampaignStatus,
  BrandCampaignStatusConfig,
} from "../../../../../shared/models/brandCampaign";
import { BrandCampaignDialogService } from "../../../brand-campaign-dialog.service";
import { BrandCampaignService } from "../../../shared/services/brand-campaign.service";
import { ContentViewType } from "../../pages/brand-content/content-view-type.enum";

@Component({
  standalone: true,
  selector: "app-brand-publications-header",
  templateUrl: "./brand-publications-header.component.html",
  styleUrl: "./brand-publications-header.component.scss",
  imports: [MatIcon, TranslateModule, NgClass, MatIconButton],
})
export class BrandPublicationsHeaderComponent {
  protected readonly ContentViewType = ContentViewType;
  public readonly campaign = signal(
    inject(BrandCampaignService).currentBrandCampaign,
  );
  public readonly activeType = input.required<ContentViewType>();
  @Output() public readonly viewTypeChange =
    new EventEmitter<ContentViewType>();

  protected readonly BrandCampaignStatusActiveValue =
    BRAND_CAMPAIGN_STATUS_FILTERS[BrandCampaignStatus.Active]!.value;
  protected readonly campaignStatus = computed<
    BrandCampaignStatusConfig | undefined
  >(() => BRAND_CAMPAIGN_STATUS_FILTERS[this.campaign().campaignBrandStatus]);
  protected readonly saving = signal(false);

  constructor(
    private readonly brandCampaignDialogService: BrandCampaignDialogService,
  ) {}

  protected async onCampaignNameEdit(): Promise<void> {
    const updatedCampaign = await this.brandCampaignDialogService.showNameEdit(
      this.campaign(),
    );

    if (updatedCampaign) {
      this.campaign.set(updatedCampaign);
    }
  }
}
